import { EmailContentDefinition } from 'modules/graphql/types';
import { cspTag } from 'modules/secureIframe';
import { EmptyStateEmail } from 'ui/illustrations';
import { removeScriptFullDoc } from 'utils/script';

import {
  PreviewContentContainer,
  PreviewContent,
  PreviewContentBody,
  PreviewContentBodyEmpty,
  PreviewContentBodyEmptyMsg,
  PreviewFrame,
} from './styles';
import { useEmailPreviewContext } from '../context/EmailPreviewContext';
import { displayContent } from '../../common/content';
import { EmailPreviewType, TemplateEditViews } from '../../common/types';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { Controls } from './Controls';
import { PreviewContentHeader } from './PreviewContentHeader';

export const Preview = () => {
  /* only show the empty state if the message in the template data is not defined, even if the
   * message is a snippet which resolves to an empty string */
  const { hasContent, liveTemplate } = useEditableFieldsContext();
  const {
    messageContent,
    previewError: hasPreviewError,
    selectedPreview,
  } = useEmailPreviewContext();
  const { view } = useQueryParamContext();
  const usePopulatedField = view === TemplateEditViews.preview;
  const emailData = (liveTemplate?.mediumData || {}) as EmailContentDefinition;
  const content = usePopulatedField ? messageContent : emailData.html || '';
  const isDesktop = selectedPreview === EmailPreviewType.Desktop;

  const shouldHidePreview = !hasContent || (hasPreviewError && view === TemplateEditViews.preview);
  return (
    <PreviewContentContainer data-test="template-editor-email-preview-content">
      <PreviewContent isDesktop={isDesktop} data-test="template-editor-email-preview">
        <PreviewContentHeader />
        {!shouldHidePreview ? (
          <PreviewContentBody isDesktop={isDesktop}>
            <PreviewFrame height={isDesktop ? 0 : `100%`} isMaxHeightPref>
              {removeScriptFullDoc(content, cspTag)}
            </PreviewFrame>
          </PreviewContentBody>
        ) : (
          <PreviewContentBodyEmpty>
            <EmptyStateEmail />
            {!hasPreviewError && (
              <PreviewContentBodyEmptyMsg>
                {displayContent.strEmptyContentEmail}
              </PreviewContentBodyEmptyMsg>
            )}
          </PreviewContentBodyEmpty>
        )}
        {isDesktop && <Controls />}
      </PreviewContent>
      {!isDesktop && <Controls />}
    </PreviewContentContainer>
  );
};

export default Preview;
